module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("13")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Das Lied")]), _vm._v(", das ich kam zu\nsingen,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nbleibt ungesungen bis auf diesen Tag.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich brachte meine Tage hin, mein Instrument"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzu stimmen und umzustimmen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der Takt kam nicht aus, die Worte"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nsind nicht recht gesetzt, nur eine Pein"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndes Wünschens ist im Herzen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Die Blüte hat sich nicht geöffnet, nur"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nder Wind seufzt vorüber.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich habe sein Angesicht nicht gesehn,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nnicht gelauscht seiner Stimme; nur seinen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nleisen Fußtritt hab ich gehört auf der"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nStraße vor meinem Hause.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der lange Tag verging damit, ihm den"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nSitz am Boden zu breiten, die Lampe"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\naber ist noch nicht entzündet, ich kann"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nihn nicht in mein Haus bitten.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich lebe der Hoffnung ihn zu treffen,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndoch dieses Treffen ist noch nicht. "), _c('a', {
    attrs: {
      "id": "page18",
      "title": "mabarosa/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a295cad0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0014.vue
// module id = 96
// module chunks = 0